//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import Table from "components/Table/Table";
import useDebounce from "helpers/useDebounce";
import { Styles } from "./styles";
import Loader from "components/Loader/Loader";
import TransactionsApi from "apis/transactions/transactions";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
// material-ui icons
import FilterListIcon from "@material-ui/icons/FilterList";
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Transactions(props) {
  const { state, dispatch } = useContext(context);
  const { getTransaction, updateTransaction } = TransactionsApi();
  const classes = Styles();
  const history = useHistory();
  const location = useLocation();

  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const [editComma, setEditComma] = useState(false);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "POINTS ADJUSTMENTS"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.transactionId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.transactionId;
      let res = await getTransaction(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdateTransaction = async () => {
    try {
      let arg = {};
      arg = { updated, transaction_id: data?.transaction_id };
      let res = await updateTransaction(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "Points Adjustments data is uploaded to our system successfully.",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let editObj = {
    points: { edit: edit, type: "text" },
    reason_code: { edit: edit, type: "text" },
  };

  const pointFormat = (point) => {
    var nfObject = new Intl.NumberFormat("en-US");
    var res = nfObject.format(point);
    return res;
  };

  const offsetParams = location?.state?.offset;
  const searchValueParams = location?.state?.searchValue;
  return (
    <React.Fragment>
      <Grid container className={classes.gridContainer}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push(`/dashboard/transactions`, {
                offsetParams,
                searchValueParams,
              });
            }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Loyalty Transaction Details</div>
          <div className={classes.type}>{`${data.type} Transaction`}</div>
        </div>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Transaction Id</span> :{" "}
            {data?.transaction_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Loyalty Member Id</span> :{" "}
            {data?.loyalty_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Order Id</span> :{" "}
            {data?.order_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Customer Account Number</span> :{" "}
            {data?.customer_account_number}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              Customer Billto Account Number
            </span>{" "}
            : {data?.customer_billto_account_number}
          </div>
        </Grid>
      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Promotional Details</div>
        </div>
        {data?.transaction_status === "Processed" && (
          <Grid item xs={12} sm={6} className={classes.gridItem}>
            <Grid>
              {edit && (
                <Button
                  className={classes.editCancelBtn}
                  onClick={() => {
                    setData(dataClone);
                    setEdit(false);
                  }}
                >
                  cancel
                </Button>
              )}
            </Grid>
            <Grid>
              <Button
                className={classes.editBtn}
                onClick={() => {
                  !edit ? setEditComma(true) : setEditComma(false);
                  if (edit) {
                    if (Object.keys(updated).length > 0) {
                      handleUpdateTransaction();
                      return;
                    } else setEditComma(true);
                    return toast.error("Edit atleast one field.", {
                      toastId: "update-btn",
                    });
                  } else {
                    setEdit(true);
                  }
                }}
              >
                {edit ? "Update" : "Edit"}
              </Button>
            </Grid>
          </Grid>
        )}
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Rule Id</span> : {data?.rule_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Extended Sales Amount</span> :{" "}
            {data?.extended_sales_amount?.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          {editObj["reason_code"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span className={classes.promotionalSpan}>
                  {"Reason Code"}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["reason_code"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.["reason_code"]}
                  onChange={(e) => {
                    if (editObj["reason_code"]?.type === "text") {
                      setData({
                        ...data,
                        ["reason_code"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["reason_code"]: e.target.value,
                      });
                    }
                    if (editObj["reason_code"]?.type === "number") {
                      setData({
                        ...data,
                        ["reason_code"]: parseInt(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["reason_code"]: parseInt(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>Reason Code</span> :{" "}
              {data?.reason_code}
            </div>
          )}
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          {editObj["points"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span className={classes.promotionalSpan}>
                  {"Points Earned"}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["points"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={
                    editComma ? pointFormat(data?.["points"]) : data?.["points"]
                  }
                  onChange={(e) => {
                    setEditComma(false);
                    if (editObj["points"]?.type === "text") {
                      let value = e.target.value;
                      value = value.replace(/\,/g, "");
                      if (isNaN(parseInt(value))) {
                        setData({ ...data, ["points"]: "" });
                        return;
                      }
                      setData({
                        ...data,
                        ["points"]: pointFormat(parseInt(value)),
                      });
                      setUpdated({ ...updated, ["points"]: parseInt(value) });
                    }
                    if (editObj["points"]?.type === "number") {
                      setData({
                        ...data,
                        ["points"]: parseInt(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["points"]: parseInt(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>Points Earned</span> :{" "}
              {pointFormat(data?.points)}
            </div>
          )}
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Promotional Description</span> :{" "}
            {data?.rule_description}
          </div>
        </Grid>
      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Order Details</div>
        </div>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Transaction Status</span> :{" "}
            <span
              className={
                data?.transaction_status === "Processed"
                  ? classes.processed
                  : ""
              }
            >
              {data?.transaction_status}
            </span>
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Transaction Type</span> :{" "}
            {data?.transaction_type}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Date of Transaction</span> :{" "}
            {data?.date_of_transaction}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Shipment Date</span> :{" "}
            {data?.post_date}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Brand Code</span> :{" "}
            {data?.product_brand_name_code}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Business Unit Code</span> :{" "}
            {data?.gl_cost_center_code}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Product Description</span> :{" "}
            {data?.product_short_description}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Business Unit Description</span>{" "}
            : {data?.business_unit_description}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              Line of Business Description
            </span>{" "}
            : {data?.line_of_business_description}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
